import { Sprite } from 'pixi.js';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import { ImageBgOptions } from '../../../../elements/resource/types/shape.type';
import { BackgroundService } from '../../../store/studio/background/background.service';
import {
  CanvasBackground,
  CanvasBackgroundConfig,
} from '../../canvas-background';

export class ImageBackground extends CanvasBackground {
  constructor(
    bgService: BackgroundService,
    private readonly options: ImageBgOptions,
    config: CanvasBackgroundConfig = {},
  ) {
    super(bgService, config);
    this.init();
  }

  addToCanvas() {
    this.container.removeChildren();
    this.container.addChild(this.bg);
  }

  // sprite: Sprite;

  private init() {
    const {
      url,
      fit = 'cover',
      alpha = 1,
    } = this.options || ({} as ImageBgOptions);
    if (!url) return;

    const src = url.startsWith('http')
      ? url
      : `https://private.cdn.inwedio.com/${url}`;
    const sprite = Sprite.from(src);
    sprite.alpha = alpha;
    sprite.anchor.set(0, 0);

    const applyFit = () => {
      const texW = sprite.texture.width;
      const texH = sprite.texture.height;
      if (!texW || !texH) return;

      const screenW = _screenX;
      const screenH = _screenY;
      const scaleX = screenW / texW;
      const scaleY = screenH / texH;

      if (fit === 'stretch') {
        sprite.width = screenW;
        sprite.height = screenH;
        sprite.x = 0;
        sprite.y = 0;
        return;
      }

      const scale =
        fit === 'contain' ? Math.min(scaleX, scaleY) : Math.max(scaleX, scaleY); // cover default
      sprite.scale.set(scale);
      const drawW = texW * scale;
      const drawH = texH * scale;
      sprite.x = (screenW - drawW) / 2;
      sprite.y = (screenH - drawH) / 2;
    };

    if (sprite.texture.valid) {
      applyFit();
    } else {
      // When the base texture finishes loading, fit and position
      sprite.texture.baseTexture.once('loaded', applyFit);
    }

    // Clip to screen area and add to the correct container
    sprite.mask = this.screenRectangle.element;
    this.container.addChild(sprite);
    // save as bg for consistency with other backgrounds
    (this as any).bg = sprite;
  }

  // Static background, no timeline at the moment
  setStateByTime(_time: number): void {}
}
